import dayjs from "dayjs";

//ロングページ基本情報取得API(Redux格納)
export const locationBaseData = (res: any) => {
    const locationBaseData = {
        plan_area_id: res[0].plan_area_id,
        branch: res[0].branch,
        location_type: res[0].location_type,
        location_excel_flag: res[0].location_excel_flag,
        location_excel_sequence: res[0].location_excel_sequence,
        location_excel_flag_n15: res[0].location_excel_flag_n15,
        location_excel_sequence_n15: res[0].location_excel_sequence_n15,
        child_location: res[0].child_location,
        parent_location: res[0].parent_location,
        shp_flag: res[0].shp_flag,
        task_id: res[0].task_id,
        status_id: res[0].status_id,
        status_seq: res[0].status_seq,
        sb_document_excel_path: res[0].sb_document_excel_path,
        sb_document_pdf_path: res[0].sb_document_pdf_path,
        other_document_excel_path: addIsExcludedProperty(JSON.parse(res[0].other_document_excel_path)),
        other_document_pdf_path: addIsExcludedProperty(JSON.parse(res[0].other_document_pdf_path)),
        rr_document_pdf_path: JSON.parse(res[0].rr_document_pdf_path),
        map_excel_path: res[0].map_excel_path,
        map_excel_user: res[0].map_excel_user,
        map_pdf_path: res[0].map_pdf_path,
        map_pdf_user: res[0].map_pdf_user,
        impact_judge_pdf_path: res[0].impact_judge_pdf_path,
        impact_judge_pdf_user: res[0].impact_judge_pdf_user,
        trade_area_reality_flag: res[0].trade_area_reality_flag,
        cover_rr_comment: res[0].cover_rr_comment,
        storeopeningconditions_rr_comment: res[0].storeopeningconditions_rr_comment,
        trade_area_rr_comment: res[0].trade_area_rr_comment,
        pictuer_rr_comment: res[0].pictuer_rr_comment,
        donation_rr_comment: res[0].donation_rr_comment,
        traffic_rr_comment: res[0].traffic_rr_comment,
        conflict_rr_comment: res[0].conflict_rr_comment,
        impact_rr_comment: res[0].impact_rr_comment,
        map_rr_comment: res[0].map_rr_comment,
        drawing_rr_comment: res[0].drawing_rr_comment,
        trends_file_path: res[0].trends_file_path !== "" ? JSON.parse(res[0].trends_file_path): [],
        other_document_rr_path: res[0].other_document_rr_path !== "" ? JSON.parse(res[0].other_document_rr_path): [],
        approval_pdf_path: res[0].approval_pdf_path !== "" ? JSON.parse(res[0].approval_pdf_path): [],
        confirm_pdf_path: res[0].confirm_pdf_path !== "" ? JSON.parse(res[0].confirm_pdf_path): [],
        request_pdf_path: res[0].request_pdf_path !== "" ? JSON.parse(res[0].request_pdf_path): [],
        gm_sent_back_flag: res[0].gm_sent_back_flag,
    };
    return locationBaseData;
};

//isExcludedプロパティが存在しない場合はfalseを追加し、
//既存のプロパティを保持したまま新しいオブジェクトを返す関数
export const addIsExcludedProperty = (parsedData: any[]): any[] => {
    // mapメソッドを使用して展開
    return parsedData.map((item: any) => {
        // isExcludedプロパティがない場合はfalseを追加
        if (!item.hasOwnProperty("isExcluded")) {
            item.isExcluded = false;
        }

        return {
            file_name: item.file_name,
            file_path: item.file_path,
            upload_date: item.upload_date,
            upload_staff_number: item.upload_staff_number,
            isExcluded: item.isExcluded, // 既存のプロパティをそのまま使用
        };
    });
};

//ロングページ基本情報API登録
export const upsertlocationBaseParam = (
    objLocationBase: any,
    plan_area_id: any,
    branch: any
) => {
    const params = {
        mode: "regist",
        endPoint: "/location/Base/v1/regist",
        query: {
            plan_area_id: plan_area_id,
            branch: branch,
            location_type: objLocationBase.location_type,
            location_excel_flag: objLocationBase.location_excel_flag,
            location_excel_sequence: objLocationBase.location_excel_sequence,
            location_excel_flag_n15: objLocationBase.location_excel_flag_n15,
            location_excel_sequence_n15: objLocationBase.location_excel_sequence_n15,
            child_location: objLocationBase.child_location,
            parent_location: objLocationBase.parent_location,
            shp_flag: objLocationBase.shp_flag,
            sb_document_excel_path: objLocationBase.sb_document_excel_path,
            sb_document_pdf_path: objLocationBase.sb_document_pdf_path,
            other_document_excel_path: JSON.stringify(objLocationBase.other_document_excel_path),
            other_document_pdf_path: JSON.stringify(objLocationBase.other_document_pdf_path),
            rr_document_pdf_path: JSON.stringify(objLocationBase.rr_document_pdf_path),
            map_excel_path: objLocationBase.map_excel_path,
            map_excel_user: objLocationBase.map_excel_user,
            map_pdf_path: objLocationBase.map_pdf_path,
            map_pdf_user: objLocationBase.map_pdf_user,
            impact_judge_pdf_path: objLocationBase.impact_judge_pdf_path,
            impact_judge_pdf_user: objLocationBase.impact_judge_pdf_user,
            trade_area_reality_flag: objLocationBase.trade_area_reality_flag,
            cover_rr_comment: objLocationBase.cover_rr_comment,
            storeopeningconditions_rr_comment: objLocationBase.storeopeningconditions_rr_comment,
            trade_area_rr_comment: objLocationBase.trade_area_rr_comment,
            pictuer_rr_comment: objLocationBase.pictuer_rr_comment,
            donation_rr_comment: objLocationBase.donation_rr_comment,
            traffic_rr_comment: objLocationBase.traffic_rr_comment,
            conflict_rr_comment: objLocationBase.conflict_rr_comment,
            impact_rr_comment: objLocationBase.impact_rr_comment,
            map_rr_comment: objLocationBase.map_rr_comment,
            drawing_rr_comment: objLocationBase.drawing_rr_comment,
            trends_file_path: JSON.stringify(objLocationBase.trends_file_path),
            other_document_rr_path: JSON.stringify(objLocationBase.other_document_rr_path),
            approval_pdf_path: JSON.stringify(objLocationBase.approval_pdf_path),
            confirm_pdf_path: JSON.stringify(objLocationBase.confirm_pdf_path),
            request_pdf_path: JSON.stringify(objLocationBase.request_pdf_path),
            log_type: "0", //ログ用 項目更新 log_type=0
        },
    };
    return params;
};

//アップロード JSON形式データ加工
export const uploadFileJsonPathFunc = (res: any, userId: string) => {
    let filePath = "";

    if (res.fullPath.includes("/excel")) {
        filePath = "/excel/" + res.name;
    } else if (res.fullPath.includes("/pdf")) {
        filePath = "/pdf/" + res.name;
    } else if (res.fullPath.includes("/rr_document")) {
        filePath = "/rr_document/" + res.name;
    } else if (res.fullPath.includes("/drawing")) {
        filePath = "/drawing/" + res.name;
    }

    return {
        file_name: res.name,
        file_path: filePath,
        upload_date: dayjs(res.timeCreated).format("YYYY/MM/DD HH:mm:ss"),
        upload_staff_number: userId,
    };
};

//その他資料RR用JSON形式データ加工
export const uploadRRFileJsonFunc = (
    res: any,
    userId: string,
    userName: string,
    rrType: string,
    mergeOrder: string = ""
) => {
    // rrTypeに応じてパスを生成
    let filePath;
    if (rrType === "01_color_mail") {
        filePath = "/pdf/other_RR/01_color_mail/" + res.name;
    } else if (rrType === "02_basis_sheet") {
        filePath = "/pdf/other_RR/02_basis_sheet/" + res.name;
    } else if (rrType === "99_other") {
        filePath = "/pdf/other_RR/99_other/" + res.name;
    }

    const baseObject = {
        file_name: res.name,
        upload_date: dayjs(res.timeCreated).format("YYYY/MM/DD HH:mm:ss"),
        upload_user_id: userId,
        upload_user_name: userName,
        path: filePath,
        other_rr_type: rrType,
    };

    // other_rr_type が "99_other" の場合のみ merge_order プロパティを追加
    if (rrType === "99_other") {
        return {
            ...baseObject,
            merge_order: mergeOrder,
        };
    }

    return baseObject;
};

//調査書基本テーブル ファイルアップロード
export const upsertLocationBaseFileParam = (
    objLocationBase: any,
    plan_area_id: any,
    branch: any,
    uploadFile: any,
    column: string,
    fileName: string
) => {
    const params = {
        mode: "regist",
        endPoint: "/location/Base/v1/regist",
        query: locationBaseFileQuery(
            objLocationBase,
            plan_area_id,
            branch,
            uploadFile,
            column,
            fileName
        ),
    };
    return params;
};

//調査書基本テーブル ファイルアップロードquery
export const locationBaseFileQuery = (
    objLocationBase: any,
    plan_area_id: any,
    branch: any,
    uploadFile: any,
    column: string,
    fileName: string
) => {
    let other_document_excel_path = objLocationBase.other_document_excel_path;
    let other_document_pdf_path = objLocationBase.other_document_pdf_path;
    let rr_document_pdf_path = objLocationBase.rr_document_pdf_path;
    let other_document_rr_path = objLocationBase.other_document_rr_path;
    let approval_pdf_path = objLocationBase.approval_pdf_path;

    if (column === "other_document_excel_path") {
        other_document_excel_path = [].concat(
            objLocationBase.other_document_excel_path,
            uploadFile
        );
    } else if (column === "other_document_pdf_path") {
        other_document_pdf_path = [].concat(
            objLocationBase.other_document_pdf_path,
            uploadFile
        );
    } else if (column === "rr_document_pdf_path") {
        rr_document_pdf_path = [].concat(
            objLocationBase.rr_document_pdf_path,
            uploadFile
        );
    } else if (column === "other_document_rr_path") {
        // other_document_rr_pathの場合は、uploadFileで更新
        other_document_rr_path = uploadFile;
    } else if (column === "approval_pdf_path") {
        // approval_pdf_pathの場合は、1つのファイルしか存在しないためuploadFileで更新
        approval_pdf_path = uploadFile;
    }

    const logStatus = setLogStatus(column, true, fileName);

    return {
        plan_area_id: plan_area_id,
        branch: branch,
        location_type: objLocationBase.location_type,
        location_excel_flag: objLocationBase.location_excel_flag,
        location_excel_sequence: objLocationBase.location_excel_sequence,
        location_excel_flag_n15: objLocationBase.location_excel_flag_n15,
        location_excel_sequence_n15: objLocationBase.location_excel_sequence_n15,
        child_location: objLocationBase.child_location,
        parent_location: objLocationBase.parent_location,
        shp_flag: objLocationBase.shp_flag,
        sb_document_excel_path: objLocationBase.sb_document_excel_path,
        sb_document_pdf_path: objLocationBase.sb_document_pdf_path,
        other_document_excel_path: JSON.stringify(addIsExcludedProperty(other_document_excel_path)),
        other_document_pdf_path: JSON.stringify(addIsExcludedProperty(other_document_pdf_path)),
        rr_document_pdf_path: JSON.stringify(rr_document_pdf_path),
        map_excel_path: objLocationBase.map_excel_path,
        map_excel_user: objLocationBase.map_excel_user,
        map_pdf_path: objLocationBase.map_pdf_path,
        map_pdf_user: objLocationBase.map_pdf_user,
        impact_judge_pdf_path: objLocationBase.impact_judge_pdf_path,
        impact_judge_pdf_user: objLocationBase.impact_judge_pdf_user,
        trade_area_reality_flag: objLocationBase.trade_area_reality_flag,
        cover_rr_comment: objLocationBase.cover_rr_comment,
        storeopeningconditions_rr_comment: objLocationBase.storeopeningconditions_rr_comment,
        trade_area_rr_comment: objLocationBase.trade_area_rr_comment,
        pictuer_rr_comment: objLocationBase.pictuer_rr_comment,
        donation_rr_comment: objLocationBase.donation_rr_comment,
        traffic_rr_comment: objLocationBase.traffic_rr_comment,
        conflict_rr_comment: objLocationBase.conflict_rr_comment,
        impact_rr_comment: objLocationBase.impact_rr_comment,
        map_rr_comment: objLocationBase.map_rr_comment,
        drawing_rr_comment: objLocationBase.drawing_rr_comment,
        trends_file_path: JSON.stringify(objLocationBase.trends_file_path),
        other_document_rr_path: JSON.stringify(other_document_rr_path),
        approval_pdf_path: JSON.stringify(approval_pdf_path),
        confirm_pdf_path: JSON.stringify(objLocationBase.confirm_pdf_path),
        request_pdf_path: JSON.stringify(objLocationBase.request_pdf_path),
        // ログ用
        log_type: logStatus.log_type,
        target_table: logStatus.target_table,
        target_column: logStatus.target_column,
        target_before_value: logStatus.target_before_value,
        target_after_value: logStatus.target_after_value,
    };
};

//調査書基本テーブル ファイル削除
export const upsertLocationBaseDeleteFileParam = (
    objLocationBase: any,
    plan_area_id: any,
    branch: any,
    uploadFileList: any,
    column: string,
    fileName: string
) => {
    const params = {
        mode: "regist",
        endPoint: "/location/Base/v1/regist",
        query: locationBaseDeleteFileQuery(
            objLocationBase,
            plan_area_id,
            branch,
            uploadFileList,
            column,
            fileName
        ),
    };
    return params;
};

//調査書基本テーブル ファイル削除query
export const locationBaseDeleteFileQuery = (
    objLocationBase: any,
    plan_area_id: any,
    branch: any,
    uploadFileList: any,
    column: string,
    fileName: string
) => {
    let other_document_excel_path = objLocationBase.other_document_excel_path;
    let other_document_pdf_path = objLocationBase.other_document_pdf_path;
    let rr_document_pdf_path = objLocationBase.rr_document_pdf_path;
    let other_document_rr_path = objLocationBase.other_document_rr_path;

    if (column === "other_document_excel_path") {
        other_document_excel_path = uploadFileList;
    } else if (column === "other_document_pdf_path") {
        other_document_pdf_path = uploadFileList;
    } else if (column === "rr_document_pdf_path") {
        rr_document_pdf_path = uploadFileList;
    } else if (column === "other_document_rr_path") {
        other_document_rr_path = uploadFileList;
    }
    const logStatus = setLogStatus(column, false, fileName);

    return {
        plan_area_id: plan_area_id,
        branch: branch,
        location_type: objLocationBase.location_type,
        location_excel_flag: objLocationBase.location_excel_flag,
        location_excel_sequence: objLocationBase.location_excel_sequence,
        location_excel_flag_n15: objLocationBase.location_excel_flag_n15,
        location_excel_sequence_n15: objLocationBase.location_excel_sequence_n15,
        child_location: objLocationBase.child_location,
        parent_location: objLocationBase.parent_location,
        shp_flag: objLocationBase.shp_flag,
        sb_document_excel_path: objLocationBase.sb_document_excel_path,
        sb_document_pdf_path: objLocationBase.sb_document_pdf_path,
        other_document_excel_path: JSON.stringify(addIsExcludedProperty(other_document_excel_path)),
        other_document_pdf_path: JSON.stringify(addIsExcludedProperty(other_document_pdf_path)),
        rr_document_pdf_path: JSON.stringify(rr_document_pdf_path),
        map_excel_path: objLocationBase.map_excel_path,
        map_excel_user: objLocationBase.map_excel_user,
        map_pdf_path: objLocationBase.map_pdf_path,
        map_pdf_user: objLocationBase.map_pdf_user,
        impact_judge_pdf_path: objLocationBase.impact_judge_pdf_path,
        impact_judge_pdf_user: objLocationBase.impact_judge_pdf_user,
        trade_area_reality_flag: objLocationBase.trade_area_reality_flag,
        cover_rr_comment: objLocationBase.cover_rr_comment,
        storeopeningconditions_rr_comment: objLocationBase.storeopeningconditions_rr_comment,
        trade_area_rr_comment: objLocationBase.trade_area_rr_comment,
        pictuer_rr_comment: objLocationBase.pictuer_rr_comment,
        donation_rr_comment: objLocationBase.donation_rr_comment,
        traffic_rr_comment: objLocationBase.traffic_rr_comment,
        conflict_rr_comment: objLocationBase.conflict_rr_comment,
        impact_rr_comment: objLocationBase.impact_rr_comment,
        map_rr_comment: objLocationBase.map_rr_comment,
        drawing_rr_comment: objLocationBase.drawing_rr_comment,
        trends_file_path: JSON.stringify(objLocationBase.trends_file_path),
        other_document_rr_path: JSON.stringify(other_document_rr_path),
        approval_pdf_path: JSON.stringify(objLocationBase.approval_pdf_path),
        confirm_pdf_path: JSON.stringify(objLocationBase.confirm_pdf_path),
        request_pdf_path: JSON.stringify(objLocationBase.request_pdf_path),
        // ログ用
        log_type: logStatus.log_type,
        target_table: logStatus.target_table,
        target_column: logStatus.target_column,
        target_before_value: logStatus.target_before_value,
        target_after_value: logStatus.target_after_value,
    };
};

// ログステータス
const setLogStatus = (column: string, isUpload: boolean, fileName: string) => {
    let log_type = "";
    let target_table = "";
    let target_column = "";
    let target_before_value = "";
    let target_after_value = "";
    let target_file_name = fileName;

    switch (column) {
        case "other_document_excel_path":
        case "other_document_pdf_path":
            log_type = "8";
            target_table = "その他資料";
            break;
        case "rr_document_pdf_path":
            log_type = "9";
            target_table = "RR内部用";
            break;
        case "other_document_rr_path":
            log_type = "9";
            target_table = "RR内部用ドキュメント";
            break;
    }
    target_column = isUpload ? "ファイルアップロード" : "ファイル削除";
    target_before_value = isUpload ? "" : target_file_name;
    target_after_value = isUpload ? target_file_name : "";

    return {
        log_type: log_type,
        target_table: target_table,
        target_column: target_column,
        target_before_value: target_before_value,
        target_after_value: target_after_value,
    };
};

//other_RR用バケットパス生成
export const getOtherRRBucketPath = (planAreaId: string, branch: string, rrType: string): string => {
    const basePath = `${planAreaId}/${branch}/pdf/other_RR`;
    return `${basePath}/${rrType}/`;
};

//other_RR 99_other重複ファイルチェック
export const checkOtherRRDuplicateFile = (fileName: string, otherDocumentRRPath: any[]): boolean => {
    const existingSameNameFiles = otherDocumentRRPath.filter(
        (item: any) => item.other_rr_type === "99_other" && item.file_name === fileName
    );
    
    return existingSameNameFiles.length === 0;
};
